import { Expose } from 'class-transformer';
import { UC_TOGGLE_STATUS } from './userInfo.interface';

/**
 * FES 开关状态模型(数据来源：query_user_toggle_status，由 fastescrow 提供)
 */
export class ToggleStatusModel {
  /**
   * FES 开关状态：0 CREATED / 1 DISABLED / 2 ENABLED。
   * 判断逻辑：只要不是 ENABLED 都视为"未开启"。
   */
  @Expose()
  status!: UC_TOGGLE_STATUS;
}
